var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.75,
    height: 20.5,
    viewBox: "0 0 17.75 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M20.621,8.45A8.626,8.626,0,0,0,12,1.75h-.01a8.624,8.624,0,0,0-8.62,6.69c-1.17,5.16,1.99,9.53,4.85,12.28a5.422,5.422,0,0,0,7.55,0C18.631,17.97,21.791,13.61,20.621,8.45ZM12,13.46a3.15,3.15,0,1,1,3.15-3.15A3.15,3.15,0,0,1,12,13.46Z",
    transform: "translate(-3.121 -1.75)",
    fill: "#f3903a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bfc10a338d4d133a04aab115010a1890.svg";
export { ForwardRef as ReactComponent };